export default {
  title: 'PROVIDER CANCELLATION FEES',
  items: {
    EnableChargeCancels: {
      label: 'Enable Provider Cancellation Fees',
      type: 'boolean'
    },
    CancellationFeeBonusFarePercentage: {
      label: 'Bonus Fare Percentage',
      type: 'integer',
      unit: 'percent'
    },
    EnableNoChargeCancel: {
      label: 'Enable No Cancellation Fee ',
      type: 'boolean'
    },
    NoChargeCancelTimeLtPUTime: {
      label: 'No Cancellation Fee Window',
      type: 'integer',
      unit: 'seconds'
    },
    EnableChargeCancelTier1: {
      label: 'Tier 1 - Enable Cancellation Fee',
      type: 'boolean'
    },
    ChargeCancelTimeLtPUTimeTier1: {
      label: 'Tier 1 - Cancellation Fee Window',
      type: 'integer',
      unit: 'seconds'
    },
    ChargeCancelPercentTier1: {
      label: 'Tier 1 - Cancellation Fee Percentage',
      type: 'integer',
      unit: 'percent'
    },
    EnableChargeCancelTier2: {
      label: 'Tier 2 - Enable Cancellation Fee',
      type: 'boolean'
    },
    ChargeCancelTimeLtPUTimeTier2: {
      label: 'Tier 2 - Cancellation Fee Window',
      type: 'integer',
      unit: 'seconds'
    },
    ChargeCancelPercentTier2: {
      label: 'Tier 2 - Cancellation Fee Percentage',
      type: 'integer',
      unit: 'percent'
    },
    EnableFinalChargeCancel: {
      label: 'Final Tier - Enable Cancellation Fee',
      type: 'boolean'
    },
    FinalChargeCancelPercent: {
      label: 'Final Tier - Cancellation Fee Percentage',
      type: 'integer',
      unit: 'percent'
    },
    CancelFeeTimeout: {
      label: 'Cancellation Fee Timeout',
      type: 'integer',
      unit: 'minutes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/provider-cancellation-fees.js